
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import httpClient from "../../store/httpClient";
import { PendingOrderDto } from "../../dtos/pendingOrderDto";
import Moment from "moment";

@Component
export default class PendingOrder extends Vue {
	@Prop()
	private pendingOrder!: PendingOrderDto;
	private deleteOrderDialog: boolean = false;

	private get summaryText() {
		return this.$t("catalogue.pendingOrder.summary", {
			date: Moment(String(this.pendingOrder.requestedAt)).format("DD.MM.YYYY"),
			firstname: this.pendingOrder.requestedByFirstname,
			lastname: this.pendingOrder.requestedByLastname,
			count: this.pendingOrder.positions.length,
		});
	}

	private get confirmDeleteText() {
		return this.$t("catalogue.pendingOrder.deleteDialog.text", {
			firstname: this.pendingOrder.requestedByFirstname,
			lastname: this.pendingOrder.requestedByLastname,
			count: this.pendingOrder.positions.length,
		});
	}

	private async deletePendingOrder() {
		try {
			await httpClient().delete(`order/DeletePendingOrder?cartId=${this.pendingOrder.id}`);
			this.$emit("deleted", this.pendingOrder.id);
			this.deleteOrderDialog = false;
		} catch (e) {
			console.error(e);
		}
	}

	private async addToCart() {
		this.pendingOrder.isInCart = true;
		const articleIds = this.pendingOrder.positions.map((p) => p.articleId);
		await this.$store.dispatch("loadMissingArticles", articleIds);
		this.$store.dispatch("loadSavedCartIntoCurrentCart", this.pendingOrder.positions);
		this.$router.push({ name: "Checkout" });
	}
}
